<template>
  <div>
    <el-dialog :title="`${isAdd ? '添加' : '修改'}联系人`" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
      <el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="联系人姓名" prop="contact_name">
          <el-input v-model="form.contact_name" maxlength="20" placeholder="请输入联系人姓名" />
        </el-form-item>
        <el-form-item label="微信号">
          <el-input v-model="form.wechat_account" maxlength="20" placeholder="请输入微信号" />
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.mobile" maxlength="11" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import throttle from 'lodash/throttle'
import { addinstitutionContact, editinstitutionContact } from '@/api/secondColonelManage'

export default {
  name: 'contactDialog',
  data () {
    return {
      isAdd: true,
      dialogVisible: false,
      team_institution_id: '',
      contact_id: '',
      form: {
        wechat_account: '',
        contact_name: '',
        remark: '',
        mobile: ''
      },
      rules: {
        contact_name: { required: true, message: '请输入联系人姓名', trigger: 'blur' }
      }
    }
  },
  methods: {
    show(data, isAdd) {
      if(this.isAdd = isAdd) {
        this.team_institution_id = data
      } else {
        this.contact_id = data.id
        Object.keys(this.form).forEach(key => this.form[key] = data[key])
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.form = {
        wechat_account: '',
        contact_name: '',
        remark: '',
        mobile: ''
      }
      this.team_institution_id = ''
      this.contact_id = ''
      this.$refs.ruleForm.resetFields()
      this.dialogVisible = false
    },
    submit: throttle(function() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        const { form, team_institution_id, contact_id, isAdd } = this
        const { code } = await (isAdd ? addinstitutionContact({ ...form, team_institution_id }) : editinstitutionContact({ ...form, contact_id }))
        if(code !== 0) return
        this.$message.success(`${isAdd ? '添加' : '修改'}成功`)
        this.$emit('getList')
        this.handleClose()
      })
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
.label {
  font-size: 16px;
  color: #1D1F23;
  line-height: 20px;
  height: 20px;
  border-left: 4px solid #6632FA;
  padding-left: 8px;
  margin-bottom: 16px;
}
.add-partner {
  font-size: 13px;
  color: #333;
  .add {
    cursor: pointer;
    color: #6632FA;
  }
}
</style>
